import React, { useState } from 'react';
import styles from './Components/CSS/CommonScreen.module.css'; // Import the CSS file
import { audioBannerData } from './Components/AdventureAudioSeriesData'; // Import the data

const CommonScreen = () => {
      const [currentPage, setCurrentPage] = useState(1);
      const itemsPerPage = 9;
    
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const currentItems = audioBannerData.slice(startIndex, endIndex);
    
      const totalPages = Math.ceil(audioBannerData.length / itemsPerPage);
    
      const goToNextPage = () => {
        setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
      };
    
      const goToPreviousPage = () => {
        setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
      };
    
      const handleCardClick = (itemId) => {
        // Handle card click, e.g., navigate to a different page
        console.log(`Card clicked: ${itemId}`);
        // You could use react-router-dom's Link component here
        // <Link to={`/details/${itemId}`}>...</Link>
      };
    
      return (
        <div className={styles.container}>
          <div className={styles.grid}>
            {currentItems.map(item => (
              <div
                key={item.id}
                className={styles.item}
                onClick={() => handleCardClick(item.id)} // Make card clickable
              >
                <img src={item.backgroundImage} alt={item.title} className={styles.image} />
                <div className={styles.overlay}> {/* Add overlay for hover effect */}
                  {/* You can add text or icons here if needed */}
                </div>
              </div>
            ))}
          </div>
          <div className={styles.pagination}>
            <button onClick={goToPreviousPage} disabled={currentPage === 1} className={styles.pageButton}>
              Previous
            </button>
            <span className={styles.pages}>Page {currentPage} of {totalPages}</span>
            <button onClick={goToNextPage} disabled={currentPage === totalPages} className={styles.pageButton}>
              Next
            </button>
          </div>
        </div>
      );
    };
    
export default CommonScreen;